import { invalidateEventQueries } from '@hooks/events/utils/invalidate-event-queries';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useQueryClient } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const MOVE_OFFER_TYPE = {
  OFFER_GROUP: 'offer_group',
  SECTION: 'section',
} as const;
export type MoveOfferType = (typeof MOVE_OFFER_TYPE)[keyof typeof MOVE_OFFER_TYPE];

export interface MoveOfferRequest {
  from: {
    type: MoveOfferType;
    id: string;
  };
  to: {
    type: MoveOfferType;
    id: string;
  };
  toPosition: number;
}

export const moveOffer = async (offerId: string, body: MoveOfferRequest) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/offers/${offerId}:move`;

  return request({ url, method: RequestMethod.POST, body });
};

export const useMoveOffer = (eventId: string) => {
  const queryClient = useQueryClient();

  return useGenericMutation(
    [QUERY_KEYS.moveOffer],
    async ({ offerId, body }: { offerId: string; body: MoveOfferRequest }) => moveOffer(offerId, body),
    {
      onError: () => {
        invalidateEventQueries(queryClient, eventId);
      },
      meta: {
        hideLoader: true,
      },
    }
  );
};
